import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { defaultDataAcessor } from 'src/app/core/helpers/mat-sort-data-accessor';
import { IAtividadeTipoTrabalhoFaseModel, IAtividadeTipoTrabalhoModel } from 'src/app/models/atividade-tipo-trabalho.model';
import { FiltroModel } from 'src/app/models/filtro.model';
import { IPermissaoModel } from 'src/app/models/permissao.model';
import { AuthService } from 'src/app/services/auth.service';
import { BaseListComponent } from 'src/app/shared/components/base-list/base-list.component';
import { FasesFormModalComponent } from '../fases-form-modal/fases-form-modal.component';
import { AtividadeTipoTrabalhoFaseService } from 'src/app/services/atividade-tipo-trabalho-fase.service';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-fases-list',
  templateUrl: './fases-list.component.html',
  styleUrls: ['./fases-list.component.scss']
})
export class FasesListComponent extends BaseListComponent {
  @Input() visualizar: boolean;
  @Input() model: IAtividadeTipoTrabalhoModel = {} as IAtividadeTipoTrabalhoModel;
  @Output() atualizarQuantidadeDias: EventEmitter<any> = new EventEmitter<any>();

  public dataSource = new MatTableDataSource<IAtividadeTipoTrabalhoFaseModel>([]);
  public displayedColumns: string[] = ['nome', 'descricao', 'qtdeDias'];
  public selectedModel: IAtividadeTipoTrabalhoFaseModel;
  public searchNome: string;
  public searchAtivo = true;
  public semDados = true;
  public permissoes: IPermissaoModel;
  public filtro = {} as FiltroModel;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  constructor(
    private toastr: ToastrService,
    private router: Router,
    private authService: AuthService,
    public matDialog: MatDialog,
    private atividadeTipoTrabalhoFaseService: AtividadeTipoTrabalhoFaseService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.semDados = this.model.fases.length == 0;
  }

  public buscar() {
    this.selectedModel = null;
    if (this.model.id > 0) {
      this.atividadeTipoTrabalhoFaseService
        .obterPorAtividadeTipoTrabalho(this.model.id)
        .then((res) => {
          this.model.fases = res.dados
          this.reordenar();
          this.semDados = this.model.fases.length === 0;
          this.atualizarQuantidadeDias.emit();
        })
        .catch((err) => {
          this.exibirMensagemAlerta(err.mensagem.descricao);
        })
    }
  }

  public adicionar() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";
    dialogConfig.width = "800px";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      atividadeTipoTrabalhoId: this.model.id
    };
    const modal = this.matDialog.open(
      FasesFormModalComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((sucesso) => {
      if (sucesso) {
        this.buscar();
      }
    });
    // this.router.navigate(['/fase-atividade/novo']);
  }

  public editar(id: number) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.id = "modal-component";
    dialogConfig.width = "800px";
    dialogConfig.hasBackdrop = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      atividadeTipoTrabalhoId: this.model.id,
      faseModel: this.model.fases.find(x => x.id === id)
    };
    const modal = this.matDialog.open(
      FasesFormModalComponent,
      dialogConfig
    );
    modal.afterClosed().subscribe((sucesso) => {
      if (sucesso) {
        this.buscar();
      }
    });
  }

  public excluir(id: number) {

    Swal.fire({
      title: "Excluir Fase de Atividade",
      text: "Tem certeza que deseja excluir esta fase de atividade?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Não",
    }).then(async (result) => {
      if (result.value) {
        this.atividadeTipoTrabalhoFaseService
          .excluir(id)
          .then((res) => {
            if (res.sucesso) {
              Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                text: 'Fase de atividade excluída com sucesso',
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
              });
            } else {
              this.exibirMensagemAlerta(res.mensagem.descricao);
            }
          })
          .catch((err) => {
            this.exibirMensagemErro(err.mensagem.descricao);
          })
          .finally(() => {
            this.buscar();
          });
        return;
      }
      return;
    });
  }

  onDrop(event: CdkDragDrop<string[]>) {
    let dados = event.item.data
    if (event.previousContainer === event.container) {
      moveItemInArray(this.model.fases, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
    this.model.fases.forEach((element, idx) => {
      element.ordem = (idx + 1);
    });
  }

  public reordenar() {
    this.model.fases.forEach((element, idx) => {
      element.ordem = (idx + 1);
    });
  }
}
